const CountryData = [
  {
    countryID: 1,
    countryCode: "AFG",
    countryCode2: "AF",
    countryDialNumber: "+93",
    countryName: "Afghanistan",
    flagPath: "https://flagcdn.com/w40/af.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 2,
    countryCode: "ALB",
    countryCode2: "AL",
    countryDialNumber: "+355",
    countryName: "Albania",
    flagPath: "https://flagcdn.com/w40/al.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 3,
    countryCode: "DZA",
    countryCode2: "DZ",
    countryDialNumber: "+213",
    countryName: "Algeria",
    flagPath: "https://flagcdn.com/w40/dz.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 4,
    countryCode: "AND",
    countryCode2: "AD",
    countryDialNumber: "+376",
    countryName: "Andorra",
    flagPath: "https://flagcdn.com/w40/ad.png",
    isActive: true,
    mobileLength: 6,
  },
  {
    countryID: 5,
    countryCode: "AGO",
    countryCode2: "AO",
    countryDialNumber: "+244",
    countryName: "Angola",
    flagPath: "https://flagcdn.com/w40/ao.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 6,
    countryCode: "ARG",
    countryCode2: "AR",
    countryDialNumber: "+54",
    countryName: "Argentina",
    flagPath: "https://flagcdn.com/w40/ar.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 7,
    countryCode: "ARM",
    countryCode2: "AM",
    countryDialNumber: "+374",
    countryName: "Armenia",
    flagPath: "https://flagcdn.com/w40/am.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 8,
    countryCode: "AUS",
    countryCode2: "AU",
    countryDialNumber: "+61",
    countryName: "Australia",
    flagPath: "https://flagcdn.com/w40/au.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 9,
    countryCode: "AUT",
    countryCode2: "AT",
    countryDialNumber: "+43",
    countryName: "Austria",
    flagPath: "https://flagcdn.com/w40/at.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 10,
    countryCode: "AZE",
    countryCode2: "AZ",
    countryDialNumber: "+994",
    countryName: "Azerbaijan",
    flagPath: "https://flagcdn.com/w40/az.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 11,
    countryCode: "BHR",
    countryCode2: "BH",
    countryDialNumber: "+973",
    countryName: "Bahrain",
    flagPath: "https://flagcdn.com/w40/bh.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 12,
    countryCode: "BGD",
    countryCode2: "BD",
    countryDialNumber: "+880",
    countryName: "Bangladesh",
    flagPath: "https://flagcdn.com/w40/bd.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 13,
    countryCode: "BEL",
    countryCode2: "BE",
    countryDialNumber: "+32",
    countryName: "Belgium",
    flagPath: "https://flagcdn.com/w40/be.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 14,
    countryCode: "BRA",
    countryCode2: "BR",
    countryDialNumber: "+55",
    countryName: "Brazil",
    flagPath: "https://flagcdn.com/w40/br.png",
    isActive: true,
    mobileLength: 11,
  },
  {
    countryID: 15,
    countryCode: "CAN",
    countryCode2: "CA",
    countryDialNumber: "+1",
    countryName: "Canada",
    flagPath: "https://flagcdn.com/w40/ca.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 16,
    countryCode: "CHN",
    countryCode2: "CN",
    countryDialNumber: "+86",
    countryName: "China",
    flagPath: "https://flagcdn.com/w40/cn.png",
    isActive: true,
    mobileLength: 11,
  },
  {
    countryID: 17,
    countryCode: "DNK",
    countryCode2: "DK",
    countryDialNumber: "+45",
    countryName: "Denmark",
    flagPath: "https://flagcdn.com/w40/dk.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 18,
    countryCode: "EGY",
    countryCode2: "EG",
    countryDialNumber: "+20",
    countryName: "Egypt",
    flagPath: "https://flagcdn.com/w40/eg.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 19,
    countryCode: "FRA",
    countryCode2: "FR",
    countryDialNumber: "+33",
    countryName: "France",
    flagPath: "https://flagcdn.com/w40/fr.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 58,
    countryCode: "GEO",
    countryCode2: "GE",
    countryDialNumber: "+995",
    countryName: "Georgia",
    flagPath: "https://flagcdn.com/w40/ge.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 20,
    countryCode: "DEU",
    countryCode2: "DE",
    countryDialNumber: "+49",
    countryName: "Germany",
    flagPath: "https://flagcdn.com/w40/de.png",
    isActive: true,
    mobileLength: 11,
  },
  {
    countryID: 59,
    countryCode: "GIB",
    countryCode2: "GI",
    countryDialNumber: "+350",
    countryName: "Gibraltar",
    flagPath: "https://flagcdn.com/w40/gi.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 60,
    countryCode: "GRC",
    countryCode2: "GR",
    countryDialNumber: "+30",
    countryName: "Greece",
    flagPath: "https://flagcdn.com/w40/gr.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 61,
    countryCode: "GTM",
    countryCode2: "GT",
    countryDialNumber: "+502",
    countryName: "Guatemala",
    flagPath: "https://flagcdn.com/w40/gt.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 21,
    countryCode: "HKG",
    countryCode2: "HK",
    countryDialNumber: "+852",
    countryName: "Hong Kong",
    flagPath: "https://flagcdn.com/w40/hk.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 62,
    countryCode: "HUN",
    countryCode2: "HU",
    countryDialNumber: "+36",
    countryName: "Hungary",
    flagPath: "https://flagcdn.com/w40/hu.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 63,
    countryCode: "ISL",
    countryCode2: "IS",
    countryDialNumber: "+354",
    countryName: "Iceland",
    flagPath: "https://flagcdn.com/w40/is.png",
    isActive: true,
    mobileLength: 7,
  },
  {
    countryID: 22,
    countryCode: "IND",
    countryCode2: "IN",
    countryDialNumber: "+91",
    countryName: "India",
    flagPath: "https://flagcdn.com/w40/in.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 23,
    countryCode: "IDN",
    countryCode2: "ID",
    countryDialNumber: "+62",
    countryName: "Indonesia",
    flagPath: "https://flagcdn.com/w40/id.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 24,
    countryCode: "IRN",
    countryCode2: "IR",
    countryDialNumber: "+98",
    countryName: "Iran",
    flagPath: "https://flagcdn.com/w40/ir.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 25,
    countryCode: "IRQ",
    countryCode2: "IQ",
    countryDialNumber: "+964",
    countryName: "Iraq",
    flagPath: "https://flagcdn.com/w40/iq.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 26,
    countryCode: "IRL",
    countryCode2: "IE",
    countryDialNumber: "+353",
    countryName: "Ireland",
    flagPath: "https://flagcdn.com/w40/ie.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 27,
    countryCode: "ISR",
    countryCode2: "IL",
    countryDialNumber: "+972",
    countryName: "Israel",
    flagPath: "https://flagcdn.com/w40/il.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 28,
    countryCode: "ITA",
    countryCode2: "IT",
    countryDialNumber: "+39",
    countryName: "Italy",
    flagPath: "https://flagcdn.com/w40/it.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 64,
    countryCode: "JAM",
    countryCode2: "JM",
    countryDialNumber: "+1",
    countryName: "Jamaica",
    flagPath: "https://flagcdn.com/w40/jm.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 29,
    countryCode: "JPN",
    countryCode2: "JP",
    countryDialNumber: "+81",
    countryName: "Japan",
    flagPath: "https://flagcdn.com/w40/jp.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 65,
    countryCode: "JOR",
    countryCode2: "JO",
    countryDialNumber: "+962",
    countryName: "Jordan",
    flagPath: "https://flagcdn.com/w40/jo.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 66,
    countryCode: "KAZ",
    countryCode2: "KZ",
    countryDialNumber: "+7",
    countryName: "Kazakhstan",
    flagPath: "https://flagcdn.com/w40/kz.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 30,
    countryCode: "KEN",
    countryCode2: "KE",
    countryDialNumber: "+254",
    countryName: "Kenya",
    flagPath: "https://flagcdn.com/w40/ke.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 31,
    countryCode: "KWT",
    countryCode2: "KW",
    countryDialNumber: "+965",
    countryName: "Kuwait",
    flagPath: "https://flagcdn.com/w40/kw.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 68,
    countryCode: "LBN",
    countryCode2: "LB",
    countryDialNumber: "+961",
    countryName: "Lebanon",
    flagPath: "https://flagcdn.com/w40/lb.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 69,
    countryCode: "LUX",
    countryCode2: "LU",
    countryDialNumber: "+352",
    countryName: "Luxembourg",
    flagPath: "https://flagcdn.com/w40/lu.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 32,
    countryCode: "MYS",
    countryCode2: "MY",
    countryDialNumber: "+60",
    countryName: "Malaysia",
    flagPath: "https://flagcdn.com/w40/my.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 72,
    countryCode: "MUS",
    countryCode2: "MU",
    countryDialNumber: "+230",
    countryName: "Mauritius",
    flagPath: "https://flagcdn.com/w40/mu.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 33,
    countryCode: "MEX",
    countryCode2: "MX",
    countryDialNumber: "+52",
    countryName: "Mexico",
    flagPath: "https://flagcdn.com/w40/mx.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 71,
    countryCode: "MCO",
    countryCode2: "MC",
    countryDialNumber: "+377",
    countryName: "Monaco",
    flagPath: "https://flagcdn.com/w40/mc.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 70,
    countryCode: "MAR",
    countryCode2: "MA",
    countryDialNumber: "+212",
    countryName: "Morocco",
    flagPath: "https://flagcdn.com/w40/ma.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 34,
    countryCode: "NPL",
    countryCode2: "NP",
    countryDialNumber: "+977",
    countryName: "Nepal",
    flagPath: "https://flagcdn.com/w40/np.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 35,
    countryCode: "NLD",
    countryCode2: "NL",
    countryDialNumber: "+31",
    countryName: "Netherlands",
    flagPath: "https://flagcdn.com/w40/nl.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 36,
    countryCode: "NZL",
    countryCode2: "NZ",
    countryDialNumber: "+64",
    countryName: "New Zealand",
    flagPath: "https://flagcdn.com/w40/nz.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 37,
    countryCode: "NGA",
    countryCode2: "NG",
    countryDialNumber: "+234",
    countryName: "Nigeria",
    flagPath: "https://flagcdn.com/w40/ng.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 38,
    countryCode: "NOR",
    countryCode2: "NO",
    countryDialNumber: "+47",
    countryName: "Norway",
    flagPath: "https://flagcdn.com/w40/no.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 39,
    countryCode: "OMN",
    countryCode2: "OM",
    countryDialNumber: "+968",
    countryName: "Oman",
    flagPath: "https://flagcdn.com/w40/om.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 40,
    countryCode: "PAK",
    countryCode2: "PK",
    countryDialNumber: "+92",
    countryName: "Pakistan",
    flagPath: "https://flagcdn.com/w40/pk.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 73,
    countryCode: "PER",
    countryCode2: "PE",
    countryDialNumber: "+51",
    countryName: "Peru",
    flagPath: "https://flagcdn.com/w40/pe.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 41,
    countryCode: "PHL",
    countryCode2: "PH",
    countryDialNumber: "+63",
    countryName: "Philippines",
    flagPath: "https://flagcdn.com/w40/ph.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 42,
    countryCode: "POL",
    countryCode2: "PL",
    countryDialNumber: "+48",
    countryName: "Poland",
    flagPath: "https://flagcdn.com/w40/pl.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 43,
    countryCode: "PRT",
    countryCode2: "PT",
    countryDialNumber: "+351",
    countryName: "Portugal",
    flagPath: "https://flagcdn.com/w40/pt.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 44,
    countryCode: "QAT",
    countryCode2: "QA",
    countryDialNumber: "+974",
    countryName: "Qatar",
    flagPath: "https://flagcdn.com/w40/qa.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 74,
    countryCode: "ROU",
    countryCode2: "RO",
    countryDialNumber: "+40",
    countryName: "Romania",
    flagPath: "https://flagcdn.com/w40/ro.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 75,
    countryCode: "RUS",
    countryCode2: "RU",
    countryDialNumber: "+7",
    countryName: "Russia",
    flagPath: "https://flagcdn.com/w40/ru.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 45,
    countryCode: "SAU",
    countryCode2: "SA",
    countryDialNumber: "+966",
    countryName: "Saudi Arabia",
    flagPath: "https://flagcdn.com/w40/sa.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 76,
    countryCode: "SRB",
    countryCode2: "RS",
    countryDialNumber: "+381",
    countryName: "Serbia",
    flagPath: "https://flagcdn.com/w40/rs.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 46,
    countryCode: "SGP",
    countryCode2: "SG",
    countryDialNumber: "+65",
    countryName: "Singapore",
    flagPath: "https://flagcdn.com/w40/sg.png",
    isActive: true,
    mobileLength: 8,
  },
  {
    countryID: 77,
    countryCode: "SVK",
    countryCode2: "SK",
    countryDialNumber: "+421",
    countryName: "Slovakia",
    flagPath: "https://flagcdn.com/w40/sk.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 47,
    countryCode: "ZAF",
    countryCode2: "ZA",
    countryDialNumber: "+27",
    countryName: "South Africa",
    flagPath: "https://flagcdn.com/w40/za.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 67,
    countryCode: "KOR",
    countryCode2: "KR",
    countryDialNumber: "+82",
    countryName: "South Korea",
    flagPath: "https://flagcdn.com/w40/kr.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 48,
    countryCode: "ESP",
    countryCode2: "ES",
    countryDialNumber: "+34",
    countryName: "Spain",
    flagPath: "https://flagcdn.com/w40/es.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 78,
    countryCode: "LKA",
    countryCode2: "LK",
    countryDialNumber: "+94",
    countryName: "Sri Lanka",
    flagPath: "https://flagcdn.com/w40/lk.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 49,
    countryCode: "SWE",
    countryCode2: "SE",
    countryDialNumber: "+46",
    countryName: "Sweden",
    flagPath: "https://flagcdn.com/w40/se.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 50,
    countryCode: "CHE",
    countryCode2: "CH",
    countryDialNumber: "+41",
    countryName: "Switzerland",
    flagPath: "https://flagcdn.com/w40/ch.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 51,
    countryCode: "THA",
    countryCode2: "TH",
    countryDialNumber: "+66",
    countryName: "Thailand",
    flagPath: "https://flagcdn.com/w40/th.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 52,
    countryCode: "TUR",
    countryCode2: "TR",
    countryDialNumber: "+90",
    countryName: "Turkey",
    flagPath: "https://flagcdn.com/w40/tr.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 79,
    countryCode: "UKR",
    countryCode2: "UA",
    countryDialNumber: "+380",
    countryName: "Ukraine",
    flagPath: "https://flagcdn.com/w40/ua.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 53,
    countryCode: "ARE",
    countryCode2: "AE",
    countryDialNumber: "+971",
    countryName: "United Arab Emirates",
    flagPath: "https://flagcdn.com/w40/ae.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 54,
    countryCode: "GBR",
    countryCode2: "GB",
    countryDialNumber: "+44",
    countryName: "United Kingdom",
    flagPath: "https://flagcdn.com/w40/gb.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 55,
    countryCode: "USA",
    countryCode2: "US",
    countryDialNumber: "+1",
    countryName: "United States",
    flagPath: "https://flagcdn.com/w40/us.png",
    isActive: true,
    mobileLength: 10,
  },
  {
    countryID: 80,
    countryCode: "URY",
    countryCode2: "UY",
    countryDialNumber: "+598",
    countryName: "Uruguay",
    flagPath: "https://flagcdn.com/w40/uy.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 56,
    countryCode: "VNM",
    countryCode2: "VN",
    countryDialNumber: "+84",
    countryName: "Vietnam",
    flagPath: "https://flagcdn.com/w40/vn.png",
    isActive: true,
    mobileLength: 9,
  },
  {
    countryID: 57,
    countryCode: "ZWE",
    countryCode2: "ZW",
    countryDialNumber: "+263",
    countryName: "Zimbabwe",
    flagPath: "https://flagcdn.com/w40/zw.png",
    isActive: true,
    mobileLength: 9,
  },
];

export { CountryData };
